export default "__VITE_ASSET__BZT8oHXv__"